import { gcloudStorageApi } from 'lib/api/client'
import { TraceRequest, TraceResponse } from './trace.types'

export const getTrace = async (
  request: TraceRequest
): Promise<TraceResponse> => {
  const { data } = await gcloudStorageApi.post<TraceResponse>('/trace', request)

  return data
}
